import { withSBErrorHandling } from '../types';

import { ScanbotBarcodeSDKPlugin } from './definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotImageProcessorImpl = {
  readImageData(imageFileUri: string): Promise<string> {
    return withSBErrorHandling(async () => (await ScanbotBarcodeSDKPlugin.readImageData({ imageFileUri })).result);
  },
};
